import styled from 'styled-components';

import media from '@/styles/media.style';
import { BLACK, WHITE, BG_GRAY } from '@/styles/variables.style';

export const Wrapper = styled.div`
  width: 100%;
  margin: 0;
`;

export const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 30px -20px 38px;
  text-align: center;

  ${media.tabletL`
    width: auto;
    margin: 0 80px 70px 80px;
  `};
`;

export const Title = styled.div`
  width: 100%;
  margin-bottom: 20px;
  color: ${BLACK};

  ${media.tabletL`
    margin-bottom: 30px;
    font-size: 18px;
    line-height: 20px;
  `};
`;

export const ItemsNames = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  height: 50px;
`;

export const ItemsNameLineWrapper = styled.div`
  width: 177px;
  height: 60px;
  margin: 0;
`;

export const ItemsNameWrapper = styled.div`
  display: flex;
  justify-content: left;
  align-items: center;
  width: 100%;
  height: 50px;
  background: ${({ background }) => background};
  margin: 0;
  font-size: 13px;
  font-weight: bold;
  line-height: 16px;
  color: ${BLACK};
  text-align: center;

  ${media.tabletL`
    font-size: 14px;
    padding-left: 20px;
    text-align: left;
  `};
`;

export const ItemsName = styled.div`
  margin: 0;
  width: 100%;
`;

export const ItemsLine = styled.div`
  width: 100%;
  height: 3px;
  background: ${BLACK};
  margin-top: 12px;
`;

export const Hr = styled.div`
  width: 16px;
  height: 2px;
  margin-bottom: 60px;
  background: ${BG_GRAY.COMMON_6};
`;

export const SliderWrapper = styled.div`
  position: relative;

  > .slick-slider {
    > .slick-list {
      margin: 0;
      padding: 0;
    }

    > .slick-dots {
      > li {
        > button {
          :before {
            font-size: 13px;
          }
        }
      }
    }

    > .slick-prev {
      position: absolute;
      z-index: 80;
      top: 50%;
      right: -30px;
      width: 20px;
      height: 50%;
      border-radius: 6px;
      box-shadow: 0 0 8px -3px ${BLACK};
      cursor: pointer;
      transform: translateY(-50%);

      :before {
        content: '';
        position: absolute;
        z-index: 200;
        top: 50%;
        right: 6px;
        width: 8px;
        height: 8px;
        border-left: 2px solid ${BLACK};
        border-top: 2px solid ${BLACK};
        transform: rotate(-45deg);
      }
    }

    > .slick-next {
      position: absolute;
      z-index: 80;
      top: 50%;
      right: -30px;
      width: 20px;
      height: 50%;
      border-radius: 6px;
      box-shadow: 0 0 8px -3px ${BLACK};
      cursor: pointer;
      transform: translateY(-50%);

      :before {
        content: '';
        position: absolute;
        z-index: 200;
        top: 50%;
        right: 6px;
        width: 8px;
        height: 8px;
        border-right: 2px solid ${BLACK};
        border-bottom: 2px solid ${BLACK};
        transform: rotate(-45deg);
      }
    }
  }
`;

export const SliderSyncingWrapper1 = styled.div`
  position: relative;
  ${media.tabletP`
    max-height: 400px;
  `};

  ${media.tabletL`
    max-height: 400px;
  `};

  ${media.desktop`
    max-height: 500px;
  `};
  margin-bottom: 0;

  // デザイン調整のため、この部分のブレイクポイントは tabletP (600px) で設定
  ${media.tabletP`
    margin-bottom: 70px;
  `};

  > .slick-slider {
    margin: auto;
    ${media.tabletP`
      width: unset;
    `};
    > .slick-list {
      ${media.tabletP`
        max-height: 400px;
      `};

      ${media.tabletL`
        max-height: 400px;
      `};

      ${media.desktop`
        max-height: 500px;
      `};
      margin: 0;
      padding: 0;

      .slick-track {
        ${media.tabletP`
          height: unset;
          max-height: 400px;
        `};

        ${media.tabletL`
          max-height: 400px;
        `};

        ${media.desktop`
          max-height: 500px;
        `};
        display: flex;

        // デザイン調整のため、この部分のブレイクポイントは tabletP、tabletL、desktop で設定 (横幅は固定値にした方が無難)
        > .slick-slide {
          margin: 0;
          flex-shrink: 0;

          width: calc(100vw - 124px);
          ${media.tabletP`
            width: 800px;
          `};

          ${media.tabletL`
            width: 1200px;
            padding: 0 200px;
          `};

          ${media.desktop`
            width: 1560px;
          `};
        }
      }
    }

    > .slick-prev {
      border-radius: 80px;
      cursor: pointer;
      height: 160px;
      width: 20px;
      position: absolute;
      top: calc((100vw - 124px) / 2);
      z-index: 80;
      left: -40px;

      border-radius: 6px;
      box-shadow: 0 0 8px -3px ${BLACK};
      cursor: pointer;
      transform: translateY(-50%);

      // デザイン調整のため、この部分のブレイクポイントは tabletP (600px) で設定
      ${media.tabletP`
        top: 50%;
        height: 190px;
        left: -45px;
      `};

      :before {
        content: '';
        position: absolute;
        z-index: 200;
        top: 50%;
        right: 6px;
        width: 8px;
        height: 8px;
        border-left: 2px solid ${BLACK};
        border-top: 2px solid ${BLACK};
        transform: rotate(-45deg);
      }
    }

    > .slick-next {
      border-radius: 80px;
      cursor: pointer;
      height: 160px;
      width: 20px;
      position: absolute;
      top: calc((100vw - 124px) / 2);
      z-index: 80;
      right: -40px;

      border-radius: 6px;
      box-shadow: 0 0 8px -3px ${BLACK};
      cursor: pointer;
      transform: translateY(-50%);

      // デザイン調整のため、この部分のブレイクポイントは tabletP (600px) で設定
      ${media.tabletP`
        right: -45px;
        height: 190px;
        top: 50%;
      `};

      :before {
        content: '';
        position: absolute;
        z-index: 200;
        top: 50%;
        right: 6px;
        width: 8px;
        height: 8px;
        border-right: 2px solid ${BLACK};
        border-bottom: 2px solid ${BLACK};
        transform: rotate(-45deg);
      }
    }
  }
`;

export const SliderSyncingWrapper2 = styled.div`
  width: 100vw;
  margin-left: -62px;

  ${media.tabletP`
    position: relative;
    width: unset;
    margin-left: unset;
  `};

  > .slick-slider {
    margin: 30px auto 0;
    width: ${({ slickSlideWidth }) => slickSlideWidth}px;

    // デザイン調整のため、この部分のブレイクポイントは tabletP (600px) で設定
    ${media.tabletP`
      width: ${({ slickSlideWidth }) => slickSlideWidth}px;
      height: auto;
      margin: auto;
    `};

    > .slick-list {
      margin: 0;
      padding: 0;

      > .slick-track {
        margin-left: ${({ itemLength }) => (itemLength % 2 ? '0' : '-36px')};
        ${media.tabletP`
          margin-left: ${({ itemLength }) => (itemLength % 2 ? '0' : '-50px')};
        `};
        > .slick-center {
          > div {
            > div {
              img {
                // センターに位置したサムネイル枠を黒にする
                border-bottom: 3px ${BLACK} solid;
              }
            }
          }
        }
      }
    }

    > .slick-dots {
      position: static;
      margin-top: 30px;
      ${media.tabletP`
        margin-top: 40px;
      `};
      > li {
        margin: 0 2px;
        ${media.tabletP`
          margin: 0 5px;
        `};
        > button {
          :before {
            font-size: 13px;
          }
        }
      }
    }

    > .slick-prev {
      position: absolute;
      z-index: 80;
      top: 50%;
      right: -30px;
      width: 20px;
      height: 100%;
      border-radius: 6px;
      box-shadow: 0 0 8px -3px ${BLACK};
      cursor: pointer;
      transform: translateY(-50%);

      :before {
        content: '';
        position: absolute;
        z-index: 200;
        top: 50%;
        right: 6px;
        width: 8px;
        height: 8px;
        border-left: 2px solid ${BLACK};
        border-top: 2px solid ${BLACK};
        transform: rotate(-45deg);
      }
    }

    > .slick-next {
      position: absolute;
      z-index: 80;
      top: 50%;
      right: -30px;
      width: 20px;
      height: 100%;
      border-radius: 6px;
      box-shadow: 0 0 8px -3px ${BLACK};
      cursor: pointer;
      transform: translateY(-50%);

      :before {
        content: '';
        position: absolute;
        z-index: 200;
        top: 50%;
        right: 6px;
        width: 8px;
        height: 8px;
        border-right: 2px solid ${BLACK};
        border-bottom: 2px solid ${BLACK};
        transform: rotate(-45deg);
      }
    }
  }
`;

export const CoverLeft = styled.div`
  position: absolute;
  z-index: 999;
  top: 0;
  left: 0;
  background: ${WHITE};
  width: 56px;
  height: 100%;
`;

export const CoverRight = styled.div`
  position: absolute;
  z-index: 999;
  top: 0;
  right: 0;
  background: ${WHITE};
  width: 56px;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/Slider/Slick.style.js